const wrapSharedDataWithId = (id, data) => ({
  [id]: data,
});

const getSharedDataById = (id, data) => data?.[id] || null;

export { wrapSharedDataWithId, getSharedDataById };
